export type ScaleProductId = "Scale" | "Scale4G";

export const SCALE_PRODUCT_IDS: ScaleProductId[] = ["Scale4G", "Scale"];

export const isScaleProduct = (id: string): id is ScaleProductId =>
  id === "Scale" || id === "Scale4G";

export const productPath = (id: string): string => {
  if (id === "Scale4G") return "/products/scale";
  if (id === "Scale") return "/products/scale-2g";
  return `/products/${id.toLowerCase()}`;
};

/** The delivery address, which may differ from billing, controls availability. */
export const isScaleShippingAllowed = (productIds: string[], country: string): boolean =>
  !productIds.includes("Scale") || country.toUpperCase() === "PL";
